
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 846 846"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#F6FBE5","stroke-width":"58.663","d":"M367.135 309.163a127.56 127.56 0 0 1 153.831 33.165"}}),_c('path',{attrs:{"stroke":"#94CC3F","stroke-dasharray":"1.36 9.55","stroke-width":"1.364","d":"M562.928 372.132A149.42 149.42 0 0 1 477.845 563.1"}}),_c('path',{attrs:{"stroke":"#F9CE62","stroke-width":"1.364","d":"M683.135 181.177a358.1 358.1 0 0 1 88.461 175.441"}}),_c('circle',{attrs:{"cx":"772.465","cy":"364.785","r":"7.503","stroke":"#F9CE62","stroke-width":"1.364","transform":"rotate(-10.836 772.465 364.785)"}}),_c('path',{attrs:{"stroke":"#D1ED7E","stroke-dasharray":"9.55 9.55","stroke-width":"1.364","d":"M310.357 447.652a115.3 115.3 0 0 1-.69-45.987 115.27 115.27 0 0 1 49.96-75.026 115.286 115.286 0 0 1 161.867 36.481 115.3 115.3 0 0 1 15.554 43.283"}})])
          )
        }
      }
    